{
    "LANGUAGES": {
        "EN": "English",
        "AR": "عربي"
    },
    "THEME": {
        "DARK": "الرؤية الليلية",
        "LIGHT": "نهاري"
    },
    "PHRASES": {
        "OR": "أو",
        "ALL": "الكل",
        "WELCOME": "اهلا وسهلاً",
        "WELCOME_MSG": "عزيزي {{name}}, أهلا بك في منصة نظام النجوم العالمي, لقد سجلت دخول ك {{role}}",
        "WELCOME_ENTITY": "في {{entity}}",
        "WELCOME_ORDER": "يمكنك الوصول لخدمات المنصة عبر التنقل بين خيارات الشريط الجانبي",
        "NO_RECORDS": "لا يوجد بيانات",
        "NO_OPTIONS": "لا يوجد خيارات",
        "DETAILS": "التفاصيل",
        "SUCCESS_MSG": "تمت العمليه بنجاح",
        "CHAR_LEFT": "محرف متبقي",
        "BONUS": "شامل علاوة",
        "PAGE": "صفحة",
        "OF": "من",
        "TOTAL": "الكلي",
        "WARNING": "تحذير"
    },
    "PLATFORMS": {
        "GSR": "نظام النجوم العالمي"
    },
    "ACTIONS": {
        "ACTIONS": "",
        "CONFIRM": "تأكيد",
        "SUBMIT": "حفظ",
        "CANCEL": "إلغاء",
        "CLOSE": "إغلاق",
        "YES": "نعم",
        "NO": "لا",
        "LOGIN": "تسجيل الدخول",
        "REGISTER": "سجل لتكون مقيم",
        "REG": "تسجيل",
        "REG_NOW": "تسجيل كمقيم",
        "RESET_PASS": "تجديد كلمة السر",
        "LOGOUT": "تسجيل الخروج",
        "EDIT": "تعديل",
        "SEARCH": "بحث",
        "SAVE": "حفظ",
        "SAVE_NOTIFY": "حفظ وإرسال إشعار",
        "FORGOT_PASSWORD": "هل نسيت كلمة السر؟",
        "DELETE": "إلغاء",
        "DELETE_USER": "مسح المستخدم",
        "DELETE_ITEM": "مسح عنصر",
        "ADD_USER": "إضافة مستخدم",
        "ADD_CYCLE": "إضافة دورة تقييمية",
        "EDIT_PROFILE": "إدارة الحساب",
        "CHANGE_PASSWORD": "تغيير كلمات المرور",
        "CONFIRMATION": "هل أنت متأكد أنك تريد",
        "START_CYCLE_CONFIRM": "لن تستطيع تغيير الأسئلة/الملفات المرفوعة حالما تبدأ الدورة التقييمية",
        "SELECT_ALL": "اختيار الكل",
        "MANAGE": "إدارة",
        "CLONE": "نسخ",
        "DEADLINS": "التواريخ",
        "REVIEW": "معاينة",
        "PREVIEW": "معاينة إجاباتي",
        "ACCEPT": "قبول",
        "REJECT": "رفض",
        "NEXT": "التالي",
        "BACK": "عودة",
        "ADD": "إضافة",
        "calc": "إحسب",
        "ASSIGN": "إحالة",
        "LINK_TO_UAEPASS": "الربط بالهوية الرقمية",
        "REMOVE_UAEPASS": "حذف الهوية الرقمية",
        "LINK_ACCOUNT": "ربط الحساب"
    },
    "DASHBOARD": {
        "UPLOAD_DOC": "الملفات",
        "ANSWERS": "الأجوبة",
        "ASSESSMENTS": "التقييمات",
        "TOP_ASSESSORS": "أعلى المقيمين",
        "ASSESSORS": "المقيمون",
        "CYCLES": "الدورات التقييمية",
        "NEW": "جديد",
        "ACTIVE": "نشط",
        "NEAR_DEADLINE": "انتهاء فترة رفع الملفات",
        "ENTITY_USERS": "مستخدمو الجهة",
        "TOTAL": "الكلي",
        "APPROVED": "موافق عليه",
        "PENDING": "بانتظار المعاينة",
        "REJECTED": "مرفوض",
        "CLOSED": "مغلقة",
        "OPEN": "مفتوحة",
        "PENDING_ADMIN_ACTION": "بانتظار معاينة المدير",
        "PENDING_USER_ACTION": "بانتظار معاينة المستخدم",
        "ASSESSOR_SIGNUP": "مقيم مسجل دخول",
        "ASSESSOR_APPROVED": "مقيم مقبول",
        "ASSESSOR_REJECTED": "مقيم مرفوض",
        "ANSWER_APPREOVED": "أسئلة موافق عليها",
        "ANSWER_REJECTED": "أسئلة مرفوضة",
        "COMPLETED_CYCLES": "دورة مكتملة",
        "PUPLISHED_CYCLES": "دورة منشورة",
        "OWN_CYCLE_PUPLISHED": "في دورة منشورة"
    },
    "ASSESSMENT_ACTIONS": {
        "SELF_ASSESSMENT_VIEW": "عرض التقييم الذاتي",
        "SELF_ASSESSMENT_ANSWER": "الإجابة على التقييم الذاتي",
        "ASSESSOR_ASSESSMENT_VIEW": "عرض تقييم المقيم",
        "ASSESSOR_ASSESSMENT_REVIEW": "مراجعة تقييم المقيم",
        "ASSESSOR_ASSESSMENT_ANSWER": "الإجابة على تقييم المقيم",
        "ASSESSMENT_VIEW": "عرض التقييم",
        "ASSESSMENT_REVIEW": "مراجعة التقييم",
        "ASSESSMENT_ANSWER": "الإجابة على التقييم",
        "ASSESSMENT_REPORT": "تقرير التقييم",
        "ENTITY_DOCUMENT_REVIEW": "عرض ملفات الجهة",
        "DOCUMENTS_UPLOAD": "رفع ملفات",
        "MANAG_DOC": "إدارة الملفات",
        "REVIEW_DOCS": "معاينة الملفات",
        "MANAG_EXTRA_DOC": "إدارة الملفات الإضافية",
        "REVIEW_EXTRA_DOCS": "معاينة الملفات الإضافية"
    },
    "USER_FORM": {
        "EMAIL": "البريد الالكتروني",
        "EMIRATES_ID": "رقم الهوية",
        "PASSWORD": "كلمة السر",
        "FIRST_NAME": "الاسم الأول",
        "MIDDLE_NAME": "الاسم الثاني",
        "LAST_NAME": "اسم العائلة",
        "FULL_NAME": "الاسم الكامل",
        "CURRENT_PASS": "كلمة السر الحالية",
        "NEW_PASS": "كلمة السر الجديدة",
        "CONFIRM_PASS": "تأكيد كلمة السر",
        "CV": "السيرة الذاتية",
        "PROFILE_PIC": "صورة المستخدم",
        "DELETE_PROFILE_PIC": "امسح صورة الحساب",
        "UPLOAD": "رفع السيرة الذاتية",
        "UPLOAD_FILES": "إرفاق الملفات",
        "OPTIONAL": "اختياري",
        "SUBMITTED": "عملية التسجيل تمت بنجاح، طلبك الآن تحت المراجعة",
        "PASSWORD_RESET_SUCCESS": "تم تجديد كلمة السر بنجاح، انقر الرابط الذي وصلك عبر بريدك الالكتروني لإنشاء كلمة سر جديدة",
        "PASSWORD_RESET_CONFIRM": "تم تغير كلمة السر بنجاح، الرجاء تسجيل الدخول باستعمال كلمة السر الجديدة",
        "STATUS": "الحالة",
        "REGISTER_COMPLETE": "تم التسجيل",
        "ROLE": "الدور",
        "DRAG_DROP_HINT": "قم بسحب وإسقاط الملف هنا",
        "UPLOAD_HINT": "(.pdf) الحجم الأقصى: 10MB",
        "UPLOAD_HINT_20": "(.pdf) الحجم الأقصى: 20MB",
        "NAME": "الاسم",
        "ENTITY": "الجهة",
        "ENTITY_TYPE": "نوع الجهة",
        "ENTITY_LEVEL": "مستوى الجهة",
        "SERVICE_CHANNEL_TYPE": "تصنيف قناة الخدمة ",
        "CHANNELS_TYPE": "نوع القنوات",
        "SERVICE_CHANNEL": "قناة الخدمة",
        "SUPPORT_DOC": "ملف إضافي",
        "EDIT_DOC": "تعديل الملف",
        "DELETE_DOC": "إزالة الملف",
        "ADD_DOC": "أضف ملف",
        "DOC_HINT": "يمكنك إضافة ملفين. الحجم الأقصى: 10MB",
        "DOC": "ملف",
        "VIEW_DOCS": "عرض ملفاتك",
        "NO_DOC": "لا يوجد ملف",
        "REGISTERED_FROM": "سجل من",
        "REGISTERED_TO": "سجل إلى",
        "REGISTRATION_DATE": "تاريخ التسجيل",
        "AVATAR": "صورة"
    },
    "CYCLES_FORM": {
        "LABEL": "الاسم",
        "AR_NAME": "الاسم بالعربي",
        "EN_NAME": "الاسم بالانكليزية",
        "ENTITIES": "الجهات",
        "CHANNELS": "قنوات الخدمة",
        "CHANNEL": "قناة الخدمة",
        "SERVICES": "الخدمات",
        "SERVICE_CENTER": "مركز خدمة",
        "APPLICATION": "تطبيق",
        "CALL_CENTER": "مركز اتصال",
        "WEBSITE": "موقع إلكتروني",
        "GENERAL_STATISTICS": "إحصائيات عامة",
        "UPLOAD_DOC_DEADLINE": "اَخر تاريخ لرفع الملفات",
        "EXTRA_DOC_DEADLINE": "اَخر تاريخ لرفع الملفات الإضافية",
        "ASSESSMENT_COMPLETE_DEADLINE": "تاريخ إكمال التقييم",
        "ALL_SERVICE_CHANNELS": "كل قنوات الخدمة",
        "ALL_SUB_SERVICES": "كل الخدمات الفرعية",
        "KHADAMATI": "خدماتي",
        "EDITED_AT": "عدلت في",
        "CALC_BY": "حسبت من قبل",
        "ASSIGN_BY": "أحيل من قبل",
        "NO_CALCULATION": "لا يوجد حسابات بعد",
        "NO_EXTRA_DOC": "لا يوجد ملفات إضافية بعد"
    },
    "ASSESSORS": {
        "TITLE": "المقيمين",
        "DETAILS": "معلومات المقيم",
        "SEARCH_ASSESSOR": "ابحث عن مقيم"
    },
    "USERS": {
        "TITLE": "قائمة المستخدمين",
        "DETAILS": "معلومات المستخدم"
    },
    "CYCLES": {
        "TITLE": "الدورات التقييمية",
        "DETAILS": "معلومات الدورة",
        "MANAGE_DEADLINES": "إدارة المواعيد",
        "EDIT_CYCLE": "تعديل معلومات الدورة",
        "CLONE_CYCLE": "نسخ الدورة",
        "RUN_CYCLE": "تشغيل الدورة",
        "DISCARD_CYCLE": "تجاهل الدورة",
        "COMPLETE_CYCLE": "إتمام الدورة",
        "MANAGE_ASSESSMENT": "إدارة التقييم",
        "MANAGE_QUESTIONS": "إدارة الأسئلة",
        "MANAGE_PILLARS": "إدارة المحاور",
        "MANAGE_UPLOADED_DOCUMENTS": "إدارة رفع الملفات",
        "MANAGE_STATUS": "إدارة حالة الدورة",
        "ASSIGN_ASSESSOR": "إحالة إلى مقيم",
        "SCORING": "إدارة الأوزان",
        "RESULT": "نتائج الحسابات",
        "CONFIG": "إعدادات",
        "CALC": "الحسابات",
        "OVERALL_SCORE": "الوزن الكلي",
        "GOV_AVG": "متوسط الحكومة",
        "PILLARS_SCORE": "نتيجة محاور التقييم",
        "CHANNELS_OVERALL_SCORE": "متوسط أداء قنوات الخدمة",
        "SERVICE_CHANNELS_SCORE": "نتائج قنوات الخدمة",
        "PER_ENTITY_SCORE": "نتائج الجهات",
        "BEST_ENTITIES": "أفضل الجهات",
        "PER_CHANNEL_SCORE": "الوزن تبعاً للقناة",
        "ENTITIES_SCORE": "أوزان الجهات",
        "ASSESSMENT_SCORING": "إدارة أوزان التقييم",
        "EC_SCORING": "إدارة أوزان المصادر الخارجية",
        "CYCLE_EDIT_MSG": "بإمكانك تعديل معلومات الدورة التقييمية بالذهاب إلى صفحة إدارة الدورة بالضغط على الزر التالي.",
        "MANAGE_DEADLINES_MSG": "بإمكانك إدارة تواريخ الدورة التقييمية بالضغط على الزر التالي",
        "MANAGE_ASSESSMENT_MSG": "بإمكانك إدارة و إضافة أسئلة و محاور بالضغط على الزر التالي.",
        "MANAGE_UPLOADED_DOCUMENTS_MSG": "بإمكانك إدارة رفع الملفات بالضغط على الزر التالي",
        "MANAGE_STATUS_MSG": "بإمكانك إدارة حالة الدورة التقييمية بالضغط على زر تشغيل الدورة أو إغلاقها.",
        "ASSIGN_ASSESSOR_MSG": "بإمكانك إحالة مقيم لكل جهة بالذهاب إلى صفحة إحالة مقيم بالضغط على الزر التالي",
        "SCORING_MSG": "بإمكانك تحديد أوزان المحاور أو معاملات و أولوية الأسئلة بالضغط على الزر التالي.",
        "EC_SCORING_MSG": "بإمكانك تحديد أوزان المصادر الخارجية بالضغط على الزر التالي.",
        "CALC_MSG": "بإمكانك القيام بحساب النقاط و استعراضها بالضغط على الزر التالي",
        "CONFIG_ASSESSOR_MSG": "بإمكانك إدارة إعدادات الدورة التقييمية بالضغط على الزر التالي.",
        "NO_MANAGE_ASSESSMENT_MSG": "لا يمكنك إضافة أو تعديل أسئلة أو محاور حالما تبدأ الدورة التقييمية.",
        "NO_MANAGE_UPLOADED_DOCUMENTS_MSG": "لا يمكنك إدارة رفع الملفات حالما تبدأ الدورة التقييمية.",
        "NOT_VALID_RUNCYCLE_MSG": "لا يمكنك تشغيل الدورة التقييمية قبل التأكد من ملء كامل المحاور و الأسئلة و الملفات المرفوعة.",
        "CYCLE_CLONE_MSG": "ستقوم بإنشاء دورة جديدة بناءً على: {{cycle}}. سيتم نسخ جميع الأسئلة من قنوات الدورات الحالية",
        "NO_KHADAMATI_ITEMS": "لا يوجد جهة خدماتي مطابقة",
        "PENDING_START_CYCLE": "بانتظار بدء الدورة"
    },
    "CYCLE_CONFIG": {
        "TITLE": "اعدادات الدورة التقييمية",
        "NO_EVIDENCE_W": "وزن لا يوجد أدلة",
        "SOME_EVIDENCE_W": "وزن يوجد بعض الأدلة",
        "GOOD_EVIDENCE_W": "وزن أدلة جيدة",
        "OUTSTANDING_EVIDENCE_W": "وزن أدلة متميزة",
        "ONE_PRIORITY_QUES_W": "أولوية وزن السؤال واحد",
        "TWO_PRIORITY_QUES_W": "أولوية وزن السؤال اثنان",
        "THREE_PRIORITY_QUES_W": "أولوية وزن السؤال ثلاثة",
        "FOUR_PRIORITY_QUES_W": "أولوية وزن السؤال أربعة",
        "EVIDENCE_W": "وزن الدليل",
        "QUES_W": "وزن السؤال",
        "SOURCES_W": "أوزان المصادر",
        "SOURCES": "المصادر",
        "ASSESSMENT_W": "وزن التقييم",
        "CHANNEL_OVERALL_W": "وزن القناة",
        "STARS": "النجوم",
        "STARS_RANGE": "قيم النجوم",
        "UNRATED_STAR": "غير مقيم",
        "TWO_STAR": "نجمتان",
        "THREE_STAR": "ثلاثة نجوم",
        "FOUR_STAR": "أربعة نجوم",
        "FIVE_STAR": "خمسة نجوم",
        "SIX_STAR": "ستة نجوم",
        "SEVEN_STAR": "سبعة نجوم",
        "EXTERNAL_ENTITIES": "مصادر خارجية",
        "NO_EXTERNAL_ENTITIES": "لا يوجد مصادر خارجية",
        "WEIGHT": "الوزن",
        "MULTIPLIER": "المعامل",
        "SCORE": "النتيجة",
        "AVG_SCORE": "متوسط النقاط",
        "CYCLE_AVG_SCORE": "متوسط نقاط الدورة",
        "LOW_SCORE": "0-35%",
        "MED1_SCORE": "36-60%",
        "MED2_SCORE": "61-80%",
        "HIGH_SCORE": "81-100%",
        "CYCLE_AVG": "متوسط الدورة",
        "NO_SCORE": "لا يوجد نقاط",
        "PROGRESS": "التقدم",
        "GSR_ASSESSMENT": "تقييم نظام النجوم العالمي",
        "PILLARS_W": "أوزان المحاور"
    },
    "DOCUMENTS": {
        "TITLE": "الملفات",
        "PENDING_ANSWER": "لم يقدم بعد"
    },
    "ACCOUNT": {
        "ACCOUNT": "الحساب"
    },
    "CYCLE_STATUS": {
        "PUBLISHED": "منشورة",
        "DRAFT": "مسودة",
        "COMPLETED": "مكتملة",
        "DISCARDED": "تم طرحها"
    },
    "ASSESSMENT_FORM": {
        "TITLE": "التقييمات",
        "NEW": "إضافة تقييم",
        "NAME": "اسم التقييم",
        "NEW_UPLOAD_DOC": "إضافة رفع ملفات",
        "UPLOAD_DOC_STATUS": "حالة رفع الملفات",
        "NEW_QUES": "إضافة سؤال",
        "DELETE_QUES": "حذف سؤال",
        "QUES_TEXT": "نص السؤال",
        "MATURITY_STAGES": "مراحل النضوج",
        "INITIAL": "الابتدائي",
        "EVOLUTION": "التطور",
        "MATURITY": "النضوج",
        "LEADERSHIP": "القيادة",
        "EVIDENCE_STRINGTH": "قوة الدليل",
        "PRIORITY": "أولوية السؤال",
        "QUES_TYPE": "نوع السؤال",
        "UPLOAD": "رفع ملف",
        "ADDITIONAL_DOC": "ملفات إضافية",
        "CYCLE": "الدورة التقييمية",
        "MATURITY_1_TITLE": "ابتدائي",
        "MATURITY_2_TITLE": "تطور",
        "MATURITY_3_TITLE": "نضوج",
        "MATURITY_4_TITLE": "ريادة",
        "EVIDENCE_STRINGTH_1": "لا توجد أدلة",
        "EVIDENCE_STRINGTH_2": "هناك بعض الأدلة",
        "EVIDENCE_STRINGTH_3": " أدلة جيدة",
        "EVIDENCE_STRINGTH_4": "أدلة متميزة",
        "NO_ANSWER": "لا إجابة",
        "COMMENT": "ملاحظات",
        "ASSESSOR_COMMENT": "ملاحظات المقيم",
        "ENTITY_COMMENT": "ملاحظات الجهة",
        "NOT_APPLICABLE": "غير قابل للتطبيق",
        "REPORT": "تقرير",
        "MAIN_REPORT": "الملخص التنفيذي",
        "SUB_REPORT": "نقاط القوة وفرص التحسين",
        "REPORT_TEXT": "نص التقرير",
        "STRENGTH_TEXT": "نقاط القوة",
        "WEAKNESS_TEXT": "نقاط الضعف",
        "APPROVED_Q": "الأسئلة الموافق عليها",
        "ANSWERED_Q": "أسئلة تم الإجابة عليها",
        "ANSWERED": "المجاب عليها",
        "APPROVED": "الموافق عليها",
        "NO_REPORT": "لا يوجد تقرير"
    },
    "ASSESSMENT_STATUS": {
        "PENDING": "بانتظار المعاينة",
        "VIEW": "معاينة",
        "ANSWER": "إجابة",
        "REVIEW": "مراجعة"
    },
    "PILLAR_FORM": {
        "TITLE": "تفاصيل المحاور",
        "ADD": "إضافة محور",
        "ADD_SUB": "إضافة محور فرعي",
        "ADD_SUBJ": "إضافة موضوع",
        "MANAGE": "إدارة",
        "SELECT_PILLAR_MSG": "الرجاء اختيار محور ﻹدارة الأسئلة التابعة لها.",
        "ALL": "المحاور",
        "LEVEL1": "المحاور",
        "LEVEL2": "المحاور الفرعية",
        "LEVEL3": "الموضوع"
    },
    "MAT_PAGINATOR": {
        "OF": "من",
        "FIRST_PAGE": "الصفحة الأولى",
        "ITEMS_PER_PAGE": "عنصر في الصفحة",
        "LAST_PAGE": "الصفحة الأخيرة",
        "NEXT_PAGE": "الصفحة التالية",
        "PREVIOUS_PAGE": "الصفحة السابقة"
    },
    "UAE_PASS": {
        "EXISTED_ACCOUNT_TITLE": "ربط الملف الشخصي",
        "EXISTED_ACCOUNT_MSG": "هل لديك حساب مع نظام النجوم العالمي",
        "GSR_LOGIN": "تسجيل الدخول باستخدام بيانات اعتماد نظام النجوم العالمي الخاصة بك",
        "EXISTED_ACCOUNT_NOTE": "سيتم ربط حساب UAE PASS الخاص بك بملف تعريف نظام النجوم العالمي الحالي الخاص بك",
        "NO_EXISTED_ACCOUNT_NOTE": "سيتم إنشاء ملف تعريف نظام النجوم العالمي الخاص بك بناءً على حساب UAE PASS",
        "NO_EXISTED_ACCOUNT_QUES": "ليس لديك حساب؟",
        "ONE_TIME_PROCESS_NOTE": "ملاحظة: هذه عملية تتم مرة واحدة، وسيكون تسجيل دخولك المستقبلي سلسًا"
    },
    "ERRORS": {
        "invalid_request": "قام المستخدم بإلغاء تسجيل الدخول",
        "login_required": "قام المستخدم بإلغاء تسجيل الدخول",
        "access_denied": "قام المستخدم بإلغاء تسجيل الدخول",
        "cancelledOnApp": "قام المستخدم بإلغاء تسجيل الدخول",
        "UauPass_RespError": "حدث خطأ ما أثناء تسجيل الدخول، يرجى المحاولة مرة أخرى لاحقًا!",
        "SOP1UserTypeError": "أنت غير مؤهل للوصول إلى هذه الخدمة. إما أن حسابك لم تتم ترقيته أو لديك حساب زائر. يرجى الاتصال بـ {{name}} لتتمكن من الوصول إلى الخدمة.",
        "SOP2UserTypeError": "يرجى ترقية حسابك باتباع الإرشادات الموجودة في تطبيق الهوية الرقمية",
        "UaePass_UserNotFoundError": "المستخدم غير موجود",
        "upload_file_conditions": "ملف الأيقونة يجب أن يكون من نوع svg و بحجم أقل من 50kb",
        "upload_file_size_20MB": "يجب ألا يزيد حجم الملف عن 20 ميجابايت",
        "VALIDATION_ERROR": "الرجاء ملء الحقول المطلوبة",
        "UserNotActiveError": "هذا المستخدم قيد المراجعة أو تم رفضه. يرجى التواصل بفريق الدعم لمزيد من المعلومات",
        "assessment_validation": "تأكد من إدخال كل بيانات الأسئلة المطلوبة",
        "upload_file_wrong_extension": "تنسيق الملف غير مدعوم"
    }
}
